import Vue from 'vue';
import '@/assets/styles/base.scss';

import App from './App.vue';
import router from './router';
import store from './store';
import './vant';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
